import { HiOutlineSun, HiOutlineMoon } from 'react-icons/hi';
import { useTheme } from '../../context/ThemeContext';

interface ThemeToggleProps {
  compact?: boolean;
}

function ThemeToggle({ compact = false }: ThemeToggleProps): JSX.Element {
  const { toggleTheme, isDark } = useTheme();

  if (compact) {
    return (
      <button
        className="mobile-menu-btn"
        onClick={toggleTheme}
        aria-label={isDark ? 'Cambiar a modo claro' : 'Cambiar a modo oscuro'}
      >
        {isDark ? <HiOutlineSun /> : <HiOutlineMoon />}
      </button>
    );
  }

  return (
    <div className="theme-toggle">
      <button
        className="theme-toggle-btn"
        onClick={toggleTheme}
        aria-label={isDark ? 'Cambiar a modo claro' : 'Cambiar a modo oscuro'}
      >
        {isDark ? <HiOutlineSun /> : <HiOutlineMoon />}
      </button>
    </div>
  );
}

export default ThemeToggle;